// extracted by mini-css-extract-plugin
module.exports = {"module":"select_module__388mt","label":"select_label__3CMj1","select":"select_select__XlnEk"};